import { SVGProps } from 'react';

export const ProIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 39.3 24.8" {...props}>
    <defs>
      <style>
        {`
      .st0 {
        fill: url(#linear-gradient);
      }

      .st1 {
        isolation: isolate;
      }

      .st2 {
        fill: #fff;
      }
   `}
      </style>
      <linearGradient id="linear-gradient" x1="10.6" y1="8.2" x2="40.4" y2="25.6" gradientTransform="translate(0 25.9) scale(1 -1)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0e8c8d" />
        <stop offset=".4" stopColor="#116c6d" />
        <stop offset=".8" stopColor="#145555" />
        <stop offset="1" stopColor="#154d4d" />
      </linearGradient>
    </defs>
    <g id="Layer_1-2">
      <g>
        <rect className="st0" y="0" width="39.3" height="24.8" rx="7.6" ry="7.6" />
        <g className="st1">
          <g className="st1">
            <path className="st2" d="M5.6,17.6V6.8h4.4c.1,0,.2,0,.4,0,.2,0,.3,0,.4,0,.6,0,1.1.3,1.5.6.4.3.7.7.9,1.2.2.5.3,1,.3,1.6s-.1,1.1-.3,1.6c-.2.5-.5.9-.9,1.2-.4.3-.9.5-1.5.6-.1,0-.3,0-.4,0s-.3,0-.4,0h-2.8v3.9h-1.6ZM7.2,12.2h2.7c.1,0,.2,0,.3,0,.1,0,.2,0,.3,0,.3,0,.6-.2.8-.4.2-.2.3-.4.4-.7,0-.3.1-.5.1-.8s0-.5-.1-.8-.2-.5-.4-.7c-.2-.2-.5-.3-.8-.4-.1,0-.2,0-.3,0-.1,0-.2,0-.3,0h-2.7v4Z" />
            <path className="st2" d="M15,17.6V6.8h4.4c.1,0,.2,0,.4,0,.2,0,.3,0,.4,0,.6,0,1.1.3,1.5.6.4.3.7.7.9,1.2.2.5.3,1,.3,1.6,0,.9-.2,1.6-.7,2.2-.4.6-1.1,1-2,1.2h-.6c0,0-3.1,0-3.1,0v3.9h-1.6ZM16.6,12.2h2.7c.1,0,.2,0,.3,0,.1,0,.2,0,.3,0,.3,0,.6-.2.8-.4.2-.2.3-.4.4-.7,0-.3.1-.5.1-.8s0-.5-.1-.8-.2-.5-.4-.7c-.2-.2-.5-.3-.8-.4-.1,0-.2,0-.3,0-.1,0-.2,0-.3,0h-2.7v4ZM21.3,17.6l-2.1-4.4,1.6-.4,2.3,4.8h-1.8Z" />
            <path className="st2" d="M29.3,17.8c-1.1,0-2-.2-2.8-.7-.8-.5-1.3-1.1-1.7-2s-.6-1.8-.6-2.9.2-2.1.6-2.9,1-1.5,1.7-2,1.7-.7,2.8-.7,2,.2,2.8.7c.8.5,1.3,1.1,1.7,2s.6,1.8.6,2.9-.2,2.1-.6,2.9-1,1.5-1.7,2c-.8.5-1.7.7-2.8.7ZM29.3,16.3c.8,0,1.4-.2,1.9-.5.5-.3.9-.8,1.1-1.5.3-.6.4-1.3.4-2.2s-.1-1.5-.4-2.2c-.3-.6-.6-1.1-1.1-1.4-.5-.3-1.1-.5-1.9-.5-.8,0-1.4.2-1.9.5-.5.3-.9.8-1.1,1.5s-.4,1.4-.4,2.2c0,.8.1,1.5.4,2.2s.6,1.1,1.2,1.4c.5.3,1.2.5,1.9.5Z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
